import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';

interface RuntimeEnvironment {
    isOffline: boolean;
}

export interface EnvironmentDisplay {
    name: string;
    color: string;
}

@Injectable({
    providedIn: 'root',
})
export class EnvironmentDisplayService {
    readonly display$: Observable<EnvironmentDisplay>;

    constructor(
        private readonly http: HttpClient,
        @Inject('BASE_URL') private readonly baseUrl: string
    ) {
        this.display$ = this.http.get<RuntimeEnvironment>(`${this.baseUrl}api/runtime/environment`).pipe(
            map(runtimeEnvironment => {
                const isOffline = runtimeEnvironment.isOffline;
                const hasEnvironmentName = Boolean(environment.environmentName);

                return {
                    name: isOffline
                        ? hasEnvironmentName ? `${environment.environmentName}-Offline` : 'Offline'
                        : environment.environmentName,
                    color: environment.environmentColor,
                };
            }),
            shareReplay(1)
        );
    }
}
